/**
 * 車両グループ用のスクリプト
 */
 if (is_route('send_message_for_user.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        send_message_for_user_event_set();
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.send_message_for_user_event_set = function() {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', [], true, function(){
            initialize('tree-multiselect');
        });
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id'], true);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });
}
